"use client";

import { TradingViewChart } from "@/app/components/ui";
import { TaiFuTopCoinTable, GenericTable } from "@/app/[locale]/c/[id]/component/tables";
import { FUNCTION_NAME_ENUM } from "@/app/lib/enums";
import type { PlaceholderData, Top30CoinsTaiFuIndexByIndexResponse } from "@/types";

interface InlinePlaceholderProps {
   data?: PlaceholderData;
}

/** Renders the appropriate UI component for a placeholder token that the LLM
 *  inserted in its response text. The component uses metadata from the
 *  placeholderRegistry to render charts, tables, or coin cards inline. */
const InlinePlaceholder = ({ data }: InlinePlaceholderProps) => {
   if (!data) return null;

   switch (data.type) {
      case "chart":
         return (
            <div className="my-4 w-full">
               <TradingViewChart
                  apiUrl={data.apiUrl}
                  symbol={data.symbol}
                  name={data.name || data.symbol}
                  description={data.description}
                  height={400}
                  className="w-full"
               />
            </div>
         );

      case "table": {
         const isTop30Table =
            data.functionName === FUNCTION_NAME_ENUM.getTop30CoinsTaiFuIndexByIndex;

         if (isTop30Table && data.result) {
            return (
               <TaiFuTopCoinTable
                  data={data.result as Top30CoinsTaiFuIndexByIndexResponse}
               />
            );
         }

         if (data.result) {
            return (
               <GenericTable
                  data={data.result as Record<string, any>[]}
                  title={data.functionName}
               />
            );
         }
         return null;
      }

      case "coin":
         // Future: render a CoinCard component
         return null;

      default:
         return null;
   }
};

export default InlinePlaceholder;
